// src/helpers/device.helper.ts

import { t } from "i18next";

type CheckDeviceParams = {
    deviceData?: any[];
    deviceDataArchived?: any[];
    dataDevices?: any[];
    devises: any;
    change: any;
    t: (key: string) => string;
};

export const checkIfDeviceExist = ({
    deviceData,
    deviceDataArchived,
    dataDevices,
    devises,
    change,
    t,
}: CheckDeviceParams): boolean => {
    let allData: any[] = [];
    let isDeviceExist = false;

    if (deviceData && deviceDataArchived) {
        allData =
            devises?.id === undefined
                ? [...deviceData, ...deviceDataArchived]
                : [...(dataDevices || []), ...deviceDataArchived];

        allData.forEach((el: any) => {
            if (el[t("Currency")] === change) {
                isDeviceExist = true;
            }
        });
    }

    return isDeviceExist;
};

type CheckFranchiseDeviceParams = {
    allDataShops?: any[];
    change: any;
    t: (key: string) => string;
};

export const checkIfDeviceFranchiseExist = ({
    allDataShops,
    change,
    t,
}: CheckFranchiseDeviceParams): boolean => {
    if (!allDataShops) return false;

    return Boolean(
        allDataShops.find((el: any) => el[t("Currency")] === change)
    );
};

export function fetchDataNameFranchiseArchived(allDataFanchiseArchived: any) {
    let localNamesFranchise: string[] = [];
    allDataFanchiseArchived?.forEach((el: any) => {
        localNamesFranchise.push(`${el[t("Currency")]}`);
    });
    return localNamesFranchise;
}

export function stateDevice(shopsDeviceData: any, devises: any) {
    let state: boolean = false;

    shopsDeviceData.forEach((element: any) => {
        element.subRows.forEach((el: any) => {
            if (el.id === devises.id) {
                state = el.isActive;
            }
        });
    });
    return state;
}
export function AssociateDevice(shopsDeviceData: any, devises: any) {
    let idsAssociated: any = [];
    if (shopsDeviceData !== undefined) {
        shopsDeviceData.forEach((element: any) => {
            element.subRows.forEach((el: any) => {
                if (el.id === devises.id) idsAssociated.push(el.idShop);
            });
        });
    }
    idsAssociated = [...new Set(idsAssociated)];
    return idsAssociated;
}

export function checkIfDeviceExistPays(dataShops: any) {
    let pays: string[] = [];

    dataShops.forEach((element: any) => {
        element?.archivedDevices.forEach((elt: any) => {
            pays.push(elt);
        });
        element.subRows.forEach((el: any) => {
            pays.push(el);
        });
    });
    return pays;
}
